import "./instrument";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "app/scss/style.scss";
import { ConfigProvider } from "antd";
import enGB from "antd/locale/en_GB";
import { store } from "app/store";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/en-gb";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import App from "./App";

dayjs.extend(utc); dayjs.extend(customParseFormat); dayjs.extend(updateLocale);
dayjs.locale("en-gb"); dayjs.updateLocale("en-gb", { weekStart: 1 });

if ("serviceWorker" in navigator && import.meta.env.PROD) registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        locale={enGB}
        theme={{
          // The portal's antd theme (src/index.tsx)
          token: { colorPrimary: "#4c54a0", colorBgContainerDisabled: "transparent", fontFamily: "'Montserrat', 'Roboto', sans-serif", colorText: "#3a3a49", colorTextSecondary: "#92929d", colorBorder: "#d2d2d5", borderRadius: 7 },
          components: {
            Input: { controlHeight: 50, borderRadius: 10 },
            Select: { controlHeight: 50, borderRadius: 10 },
            DatePicker: { controlHeight: 50, borderRadius: 10 },
            Button: { controlHeight: 44, borderRadius: 7, fontWeight: 600 },
            Switch: { colorPrimary: "#45b1b2" },
            Segmented: { itemSelectedBg: "#4c54a0", itemSelectedColor: "#fff", borderRadius: 10 },
          },
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
);
